<template>
  <div class="sidebar">
    <el-menu class="sidebar-el-menu" :collapse="collapse" background-color="transparent" :default-active="$route.path" text-color="#464646" active-text-color="#fff" active-background-color="#f8ab01" unique-opened router mode="vertical">
      <template v-for="item in items">
        <template v-if="item.subs">
          <el-submenu :index="item.index" :key="item.index">
            <template slot="title">
              <i :class="'icon-'+item.icon"></i><span slot="title">{{ $t(item.title) }}</span>
            </template>
            <template v-for="subItem in item.subs">
              <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index" class="secondary_main_menu">
                <template slot="title">{{ $t(subItem.title) }}</template>
                <el-menu-item v-for="(threeItem,i) in subItem.subs" :key="i" :index="threeItem.index" class="secondary_submenu">
                  {{ $t(threeItem.title) }}
                </el-menu-item>
              </el-submenu>
              <el-menu-item v-else :index="subItem.index" :key="subItem.index" @click="resolvePath($event,subItem)">
                {{ $t(subItem.title) }}
              </el-menu-item>
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="item.index" :key="item.index">
            <i :class="'icon-'+item.icon"></i><span slot="title">{{ $t(item.title) }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
import bus from '../common/bus';
import { getMenu } from "../../api";
import nutriApi from "@/api/Nutrition/index";

export default {
  data() {
    return {
      collapse: false,
    }
  },
  computed: {
    items() {
      return this.$store.state.main.menu;
    },
    // onRoutes(){
    //     return this.$route.path.replace('/', '');
    // },

  },
  created() {
    // 通过 Event Bus 进行组件间通信，来折叠侧边栏
    bus.$on('collapse', msg => {
      this.collapse = msg;
    });
    // this.onRoutes()
  },

  methods: {
    onRoutes() {
      return this.$route.path.replace('/', '');
    },
        resolvePath(e, item) {
      console.log("🚀 ~ file: sidebar.vue:65 ~ resolvePath ~ item:", item)
      if (item.index === "/nutritionAnalysis") {
        console.log('131')
        console.log('process.env.VUE_APP_SERVER_BASE_URL', process.env.VUE_APP_SERVER_BASE_URL)
        nutriApi.resolvePath().then(res => {
          console.log("🚀 ~ file: sidebar.vue:68 ~ this.$http.get ~ res:", res)
          window.open(res.data, '_blank');
        })
      }
    },
  },

  update: {
    onRoutes() {
      return this.$route.path.replace('/', '');
    },
  }
}
</script>

<style scoped>
</style>
